import { InboxOutlined } from '@ant-design/icons';
import { Button, Form, Modal, Space, Typography, Upload, message } from 'antd';
import { useEffect, useState } from 'react';

const { Dragger } = Upload;
const { Text, Title } = Typography;
const BASE_URL = process.env.REACT_APP_API_BASEURL || "";

export default function PopupItem({
	open,
	setOpen,
	item,
	onSubmit,
	loading,
	formItem,
	isCreate,
}) {
	const [fileList, setFileList] = useState([]);
	const [form] = Form.useForm();
	//nhận từ cha check isCreate = true sẽ lấy form từ  formItem truyền vào, lý do nhận để đồng bộ khi click submit show validate 
	const activeForm = isCreate ? formItem : form;

	useEffect(() => {
		if (open && item) {
			setFileList([]);
		}
	}, [open, item, activeForm]);

	const itemName = item?.itemName || "";
	const description = item?.description || "";
	const buildImageUrl = (path) => {
		if (!path) return "";
		if (/^https?:\/\//i.test(path)) return path;
		return `${BASE_URL.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
	};

	const currentImage = {
		url: buildImageUrl(item?.defaultImageUrl || item?.imageUrl),
		fileName: item?.defaultImageUrl?.split("/").pop() || item?.imageUrl?.split("/").pop() || "",
	}

	const uploadProps = {
		name: "file",
		multiple: false,
		maxCount: 1,
		fileList,
		accept: "image/jpeg,image/png,image/jpg",
		beforeUpload: (file) => {
			const isValidType = ["image/jpeg", "image/png", "image/jpg"].includes(file.type);
			if (!isValidType) {
				message.error("Only accept formats image/jpeg, image/png, image/jpg");
				return Upload.LIST_IGNORE;
			}

			const isLt10M = file.size / 1024 / 1024 < 10;
			if (!isLt10M) {
				message.error("Image size must not exceed 10MB!");
				return Upload.LIST_IGNORE;
			}

			return false; // ngăn tự động upload, tự xử lý khi submit
		},
		onChange(info) {
			// chỉ giữ lại ảnh mới nhất được chọn
			setFileList(info.fileList.slice(-1));
		},
		onRemove: () => {
			setFileList([]);
		},
	};

	const handleCancel = () => {
		setOpen(false);
		setFileList([]);
	};

	const handleFinish = () => {
		const files = fileList.map((f) => f.originFileObj).filter((file) => file instanceof File);
		if (files.length === 0) {
			message.error('Please select the photo again');
			return;
		}

		const payload = {
			id: item?.id,
			itemCode: item?.itemCode,
			newImages: files, // danh sách File thật, có thể chọn nhiều ảnh
		};
		onSubmit?.(payload);
	};

	return (
		<Modal
			open={open}
			title="Update Item Image"
			width={600}
			onCancel={handleCancel}
			maskClosable={false}
			centered
			afterClose={() => {
				setFileList([]);
			}}
			footer={
				<Space className="mt-6">
					<Button htmlType="button" onClick={handleCancel} type="text" className="font-medium" disabled={loading}>
						Cancel
					</Button>
					<Button
						type="primary"
						htmlType="button"
						className="font-medium size-16 h-8"
						disabled={loading}
						loading={loading}
						onClick={(e) => {
							e.stopPropagation();
							activeForm.submit();
						}}
					>
						Save
					</Button>
				</Space>
			}
		>
			<div style={{ display: "flex", marginBottom: 12 }}>
				<Text type="secondary" style={{ width: 110, flexShrink: 0 }}>
					Item Name
				</Text>
				<Text strong>{itemName}</Text>
			</div>

			{/* <div style={{ display: "flex", marginBottom: 20 }}>
				<Text type="secondary" style={{ width: 110, flexShrink: 0 }}>
					Description
				</Text>
				<Text>{description}</Text>
			</div> */}

			<Title style={{ marginBottom: 8, fontSize: 14 }}>
				<span style={{ color: "#ff4d4f" }}>* </span>Current Image
			</Title>
			<div
				style={{
					border: "1px solid #f0f0f0",
					borderRadius: 8,
					padding: 12,
					display: "flex",
					alignItems: "center",
					gap: 12,
					marginBottom: 24,
				}}
			>
				{
					currentImage?.url ?
						<img src={currentImage?.url} alt={''} style={{
							width: 150,
							height: "auto",
						}} />
						:
						<div
							style={{
								width: 64,
								height: 48,
								background: "#f5f5f5",
								borderRadius: 4,
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								fontSize: 10,
								color: "#bfbfbf",
								flexShrink: 0,
							}}
						>
						</div>
				}
				<Text>{currentImage.fileName}</Text>
			</div>

			<Form form={activeForm} layout="vertical" onFinish={handleFinish} component={false}>
				<Form.Item
					label="New Image"
					name="newImage"
					labelCol={{ span: 24 }}
					wrapperCol={{ span: 24 }}
					rules={[
						{
							validator: () =>
								fileList.length > 0
									? Promise.resolve()
									: Promise.reject(new Error("Please upload a new image")),
						},
					]}
				>
					<Dragger {...uploadProps} style={{ padding: "16px 0" }}>
						<p className="ant-upload-drag-icon">
							<InboxOutlined style={{ color: "#1677ff" }} />
						</p>
						<p className="ant-upload-text">
							Click or drag an image to this area to upload
						</p>
						<p className="ant-upload-hint" style={{ color: "#bfbfbf" }}>
							Only accept formats image/jpeg, image/png, image/jpg (max 10MB)
						</p>
					</Dragger>
				</Form.Item>
			</Form>
		</Modal>
	);
}